import { useState } from 'react';
export const useErrorItems = () => {
    const [errorItems, setErrorItems] = useState([]);
    const addErrorItem = (index) => {
        setErrorItems((prev) => prev.concat(index));
    };
    const isErrorItem = (index) => errorItems.includes(index);
    return {
        addErrorItem,
        isErrorItem,
    };
};
